export const columnsUser = [
    {
        name: '#',
        width: '10%',
        selector: (row, index) => index,
        cell: (row, index) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="d-flex flex-column">
                    <p className="text-truncate text-body">
                        <span className="fw-bolder">
                            {index + 1 || 'Anonymous'}
                        </span>
                    </p>
                </div>
            </div>
        ),
    },
    {
        name: 'Name',
        flexBasis: '20%',
        selector: (row) => row.name,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="d-flex flex-column">
                    <p className="text-truncate text-body">
                        <span className="fw-bolder">
                            {row.name || 'Anonymous'}
                        </span>
                    </p>
                </div>
            </div>
        ),
    },
    {
        name: 'Email',
        flexBasis: '20%',
        selector: (row) => row.email,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="d-flex flex-column">
                    <p className="text-truncate text-body">
                        <span className="fw-bolder">{row.email || 'None'}</span>
                    </p>
                </div>
            </div>
        ),
    },
    {
        name: 'Account',
        flexBasis: '50%',
        selector: (row) => row.account,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <p className="text-truncate text-body">
                    <span className="fw-bolder">{`${row.account.slice(
                        0,
                        5
                    )}...${row.account.slice(-6)}`}</span>
                    <br />
                </p>
            </div>
        ),
    },
];
